import React from 'react';
import { GDSColor, StackLayout } from '@leagueplatform/genesis-core';
import {
  FooterLinkItems,
  FooterLinkProps,
} from './footer-link-items.component';
import { useIsBelowTablet } from '../../../hooks/use-is-below-tablet/use-is-below-tablet.hook';
import {
  AssetLink,
  AssetLinkProps,
} from '../../asset-links/asset-link.component';

const FooterLinksLayoutWrapper = ({ children }: any) => {
  const isBelowTablet = useIsBelowTablet();

  return (
    <StackLayout
      orientation={isBelowTablet ? 'vertical' : 'horizontal'}
      horizontalAlignment="center"
      verticalAlignment={isBelowTablet ? 'top' : 'spaceBetween'}
      css={{
        flexWrap: isBelowTablet ? 'wrap' : 'nowrap',
        width: '100%',
      }}
    >
      {children}
    </StackLayout>
  );
};

export const FooterLinksAndIconsSection = ({
  footerLinks,
  secondaryFooterLinks,
  footerIcons,
  textColor,
}: {
  footerLinks: FooterLinkProps[];
  secondaryFooterLinks?: FooterLinkProps[];
  footerIcons?: AssetLinkProps[];
  textColor?: GDSColor;
}) => {
  const isBelowTablet = useIsBelowTablet();

  return (
    <FooterLinksLayoutWrapper>
      {/* Footer Links Section */}
      <StackLayout
        css={{
          width: '100%',
        }}
      >
        <StackLayout
          orientation={isBelowTablet ? 'vertical' : 'horizontal'}
          css={{ minWidth: '100px', flexWrap: 'wrap' }}
        >
          <FooterLinkItems
            linkItems={footerLinks}
            styleProps={{
              marginRight: isBelowTablet ? 'none' : '$two',
              typography: '$buttonTwo',
              marginBlockEnd: isBelowTablet ? '$one' : 'none',
            }}
          />
        </StackLayout>
        <StackLayout
          orientation={isBelowTablet ? 'vertical' : 'horizontal'}
          css={{ minWidth: '100px', flexWrap: 'wrap' }}
        >
          {secondaryFooterLinks && (
            <FooterLinkItems
              linkItems={secondaryFooterLinks}
              styleProps={{
                color: textColor,
                display: 'flex',
                marginRight: isBelowTablet ? 'none' : '$oneAndHalf',
                marginLeft: 'none',
                marginBottom: isBelowTablet ? '$threeQuarters' : 'none',
                textWrap: 'nowrap',
                justifyContent: isBelowTablet ? 'center' : 'start',
                fontWeight: 'normal',
              }}
            />
          )}
        </StackLayout>
      </StackLayout>
      {/* Footer Icons Section */}
      {!!footerIcons && (
        <StackLayout
          css={{
            flexWrap: isBelowTablet ? 'wrap' : 'nowrap',
            alignItems: 'center',
            flexBasis: 'auto',
          }}
          orientation="horizontal"
          horizontalAlignment={isBelowTablet ? 'center' : 'end'}
        >
          {footerIcons.map((item) => (
            <AssetLink
              key={item.url}
              src={item.src}
              alt={item.alt}
              url={item.url}
            />
          ))}
        </StackLayout>
      )}
    </FooterLinksLayoutWrapper>
  );
};
